import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  Tooltip,
  MenuItem,
  Stack,
  Paper,
  Button,
  CircularProgress,
  Tabs,
  Tab
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useFetchMDMDocuments } from "../../hooks/panelMDM/useGetMDMDocuments";
import { Panorama } from "./panelMDM/Panorama";
import { Pay } from "./panelMDM/Pay";
import { AudioUpload } from "./panelMDM/AudioUpload";
import { Indicadores } from "./panelMDM/Indicadores";
import { Secciones } from "./panelMDM/Secciones";
import { Temas } from "./panelMDM/Temas";
import { PreviewModal } from "./panelMDM/PreviewModal";
import { useSendJson } from "../../hooks/panelMDM/useSendJson";
// import UploadFileIcon from "@mui/icons-material/UploadFile";
import VisibilityIcon from "@mui/icons-material/Visibility";
// import DownloadIcon from "@mui/icons-material/Download";
import { useFetchJson } from "../../hooks/panelMDM/useGetJson";
import { useSyncN8nAudios } from "../../hooks/panelMDM/useSyncN8nAudios";
import { toastAlert } from "../../utils/AlertContext";

const opcionesData = [
  { Id_Option: 1, Name_Option: "Panorama" },
  { Id_Option: 2, Name_Option: "Pays (Graficas)" },
  { Id_Option: 3, Name_Option: "Indicadores" },
  { Id_Option: 4, Name_Option: "Secciones" },
  { Id_Option: 5, Name_Option: "Audio resumido" },
  { Id_Option: 6, Name_Option: "Audio completo" },
  { Id_Option: 7, Name_Option: "Audio resumido NV" },
  { Id_Option: 8, Name_Option: "Audio completo NV" },
  { Id_Option: 9, Name_Option: "Audio resumido CC" },
  { Id_Option: 10, Name_Option: "Audio completo CC" },
  { Id_Option: 11, Name_Option: "Análisis de medios (Gráficas)" },
];

const modulesByDocument = {
  1000372: [1, 2, 5, 6, 7, 8, 9, 10],
  1000375: [1, 2, 3, 5, 6, 7, 8, 9, 10],
  1000376: [1, 2, 5, 6, 7, 8, 9, 10],
  1000886: [1, 2, 5, 6, 7, 8, 9, 10],
  1001: [4, 5, 6],
  22252: [2, 5, 6, 7, 8, 9, 10],
  1000184: [11],
  22470: [7, 8],
  22471: [7, 8, 9, 10],
  22495: [7, 8, 9, 10],
  22496: [5, 6],
  22497: [5, 6],
  22498: [5, 6],
  22499: [5, 6],
  22500: [5, 6],
};

const tabsConfig = [
  {
    key: "mdm",
    label: "MDM",
    documents: [1000376, 1000372, 1000375, 1000886, 22252, 1001],
    modules: [1, 2, 3, 4, 5, 6],
  },
  {
    key: "nv",
    label: "Nuestra Visión",
    modules: [7, 8],
  },
  {
    key: "cc",
    label: "CiberCuba",
    modules: [9, 10],
  },
  {
    key: "personalizado",
    label: "App Selecta Intelite",
    documents: [22496, 22497, 22498, 22499, 22500, 1000184],
    modules: [5, 6, 11],
  },
];

export const MDM = () => {
  const { mdmDocuments, loading } = useFetchMDMDocuments();
  const { jsonData, loadingJson, refetchJson } = useFetchJson();
  const { syncAudios, loadingSync } = useSyncN8nAudios();
  const [dataJson, setDataJson] = useState({});
  const [docId, setDocId] = useState("");
  const [optId, setOptId] = useState(1);
  const [tabKey, setTabKey] = useState(tabsConfig[0].key);
  const fileInputRef = useRef(null);
  const [openPreview, setOpenPreview] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const isLoadingGlobal = loading || loadingJson;
  const [isUploading, setIsUploading] = useState(false);
  const [selectedAudioFile, setSelectedAudioFile] = useState(null);
  const [isUploadingCompleto, setIsUploadingCompleto] = useState(false);
  const [selectedAudioCompletoFile, setSelectedAudioCompletoFile] = useState(null);
  const [isUploadingResumidoNV, setIsUploadingResumidoNV] = useState(false);
  const [selectedAudioResumidoNVFile, setSelectedAudioResumidoNVFile] = useState(null);
  const [isUploadingCompletoNV, setIsUploadingCompletoNV] = useState(false);
  const [selectedAudioCompletoNVFile, setSelectedAudioCompletoNVFile] = useState(null);
  const [isUploadingResumidoCC, setIsUploadingResumidoCC] = useState(false);
  const [selectedAudioResumidoCCFile, setSelectedAudioResumidoCCFile] = useState(null);
  const [isUploadingCompletoCC, setIsUploadingCompletoCC] = useState(false);
  const [selectedAudioCompletoCCFile, setSelectedAudioCompletoCCFile] = useState(null);
  const [pendingAudioDocId, setPendingAudioDocId] = useState(null);
  const pendingUpdatesRef = useRef({});

  const getCurrentDate = () => new Date().toISOString();

  const {
    saveJson,
    publishJson,
    loadingSend,
    messageSend,
  } = useSendJson();

  useEffect(() => {
    if (mdmDocuments?.length && docId === "") {
      setDocId(mdmDocuments[0].ID_DOCUMENTO);
    }
  }, [mdmDocuments, docId]);

  useEffect(() => {
    if (jsonData && Object.keys(jsonData).length > 0) {
      setDataJson(jsonData);

      const firstDoc = Object.keys(jsonData)[0];
      if (firstDoc) {
        setDocId(Number(firstDoc));
      }
    }
  }, [jsonData]);

  useEffect(() => {
    if (!docId) return;

    setDataJson((prev) => {
      if (prev[docId]) return prev;

      if (docId === 1001) {
        return {
          ...prev,
          [docId]: {
            Secciones: {
              titulo: "",
              secciones: [],
            },
          },
        };
      }

      return {
        ...prev,
        [docId]: {
          Panorama: "",
          Pay: [],
          Indicadores: {
            Financieros: [],
            Economia: [],
            Criptomonedas: [],
          },
        },
      };
    });
  }, [docId]);

  const extendedDocuments = useMemo(() => {
    const extraDocs = [
      { ID_DOCUMENTO: 1001, NOMBRE_DOCUMENTO: "Mañaneras" },
      { ID_DOCUMENTO: 22252, NOMBRE_DOCUMENTO: "Internacional" },
      { ID_DOCUMENTO: 1000184, NOMBRE_DOCUMENTO: "Francisco Cervantes" },
      { ID_DOCUMENTO: 22470, NOMBRE_DOCUMENTO: "Farándula" },
      { ID_DOCUMENTO: 22471, NOMBRE_DOCUMENTO: "Deportes" },
      { ID_DOCUMENTO: 22495, NOMBRE_DOCUMENTO: "US Hispanic" },
      { ID_DOCUMENTO: 22496, NOMBRE_DOCUMENTO: "Coyuntura económica sintetizada" },
      { ID_DOCUMENTO: 22497, NOMBRE_DOCUMENTO: "Agenda económica" },
      { ID_DOCUMENTO: 22498, NOMBRE_DOCUMENTO: "Indicadores económicos" },
      { ID_DOCUMENTO: 22499, NOMBRE_DOCUMENTO: "Seguridad" },
      { ID_DOCUMENTO: 22500, NOMBRE_DOCUMENTO: "FCD" },
    ];

    const currentDocs = mdmDocuments || [];
    const missingDocs = extraDocs.filter(
      (ed) => !currentDocs.some((d) => d.ID_DOCUMENTO === ed.ID_DOCUMENTO)
    );

    return [...currentDocs, ...missingDocs];
  }, [mdmDocuments]);

  const currentTab = useMemo(
    () => tabsConfig.find((t) => t.key === tabKey) || tabsConfig[0],
    [tabKey]
  );

  const tabDocuments = useMemo(() => {
    const docs = extendedDocuments.filter((d) => {
      const id = d.ID_DOCUMENTO;
      const inTab = !currentTab.documents || currentTab.documents.includes(id);
      const hasModules = (modulesByDocument[id] || []).some((m) =>
        currentTab.modules.includes(m)
      );
      return inTab && hasModules;
    });

    if (!currentTab.documents) return docs;

    return [...docs].sort(
      (a, b) =>
        currentTab.documents.indexOf(a.ID_DOCUMENTO) -
        currentTab.documents.indexOf(b.ID_DOCUMENTO)
    );
  }, [extendedDocuments, currentTab]);

  useEffect(() => {
    if (!tabDocuments.length) return;
    if (!tabDocuments.some((d) => d.ID_DOCUMENTO === docId)) {
      setDocId(tabDocuments[0].ID_DOCUMENTO);
    }
  }, [tabDocuments, docId]);

  const allowedModules = useMemo(() => {
    const modules = (modulesByDocument[docId] || []).filter((m) =>
      currentTab.modules.includes(m)
    );
    return modules.length ? modules : [currentTab.modules[0]];
  }, [docId, currentTab]);

  useEffect(() => {
    if (docId && !allowedModules.includes(optId)) {
      setOptId(allowedModules[0]);
    }
  }, [docId, optId, allowedModules]);

  useEffect(() => {
    if (!messageSend) return;

    const isSuccess = messageSend
      .toLowerCase()
      .includes("correctamente");

    toastAlert(
      messageSend,
      isSuccess ? "success" : "error"
    );
  }, [messageSend]);

  const documento = useMemo(
    () => extendedDocuments?.find(
      (d) => d.ID_DOCUMENTO === docId
    ),
    [docId, extendedDocuments]
  );

  const opcion = useMemo(
    () => opcionesData.find(
      (o) => o.Id_Option === optId
    ),
    [optId]
  );

  const textoCombinado = `${documento?.NOMBRE_DOCUMENTO || ""
    } - ${opcion?.Name_Option || ""
    }`;

  const markAsUpdated = (docId, moduleName) => {
    if (!pendingUpdatesRef.current[docId]) {
      pendingUpdatesRef.current[docId] = new Set();
    }

    pendingUpdatesRef.current[docId].add(moduleName);
  };

  const updatePanorama = (value) => {
    markAsUpdated(docId, "Panorama");

    setDataJson((prev) => ({
      ...prev,
      [docId]: {
        ...prev[docId],
        Panorama: value,
      },
    }));
  };

  const updatePay = (value) => {
    markAsUpdated(docId, "Pay");

    setDataJson((prev) => ({
      ...prev,
      [docId]: {
        ...prev[docId],
        Pay: value,
      },
    }));
  };

  const updateIndicadores = (value) => {
    markAsUpdated(docId, "Indicadores");

    setDataJson((prev) => ({
      ...prev,
      [docId]: {
        ...prev[docId],
        Indicadores: value,
      },
    }));
  };

  const updateSecciones = (value) => {
    markAsUpdated(docId, "Secciones");

    setDataJson((prev) => ({
      ...prev,
      [docId]: {
        ...prev[docId],
        Secciones: value,
      },
    }));
  };

  const updateTemas = (value) => {
    markAsUpdated(docId, "Temas");

    setDataJson((prev) => ({
      ...prev,
      [docId]: {
        ...prev[docId],
        Temas: value,
      },
    }));
  };

  const updateMarkers = (moduleName, value) => {
    markAsUpdated(docId, `${moduleName}_marcadores`);

    setDataJson((prev) => ({
      ...prev,
      [docId]: {
        ...prev[docId],
        [`${moduleName}_marcadores`]: value,
      },
    }));
  };

  const handleDeleteAudio = (moduleName) => {
    markAsUpdated(docId, moduleName);
    markAsUpdated(docId, `${moduleName}_marcadores`);

    if (moduleName === "Audio") {
      setSelectedAudioFile(null);
    } else if (moduleName === "AudioCompleto") {
      setSelectedAudioCompletoFile(null);
    } else if (moduleName === "AudioResumidoNV") {
      setSelectedAudioResumidoNVFile(null);
    } else if (moduleName === "AudioCompletoNV") {
      setSelectedAudioCompletoNVFile(null);
    } else if (moduleName === "AudioResumidoCC") {
      setSelectedAudioResumidoCCFile(null);
    } else if (moduleName === "AudioCompletoCC") {
      setSelectedAudioCompletoCCFile(null);
    }

    setDataJson((prev) => ({
      ...prev,
      [docId]: {
        ...prev[docId],
        [moduleName]: null,
        [`${moduleName}_marcadores`]: null,
      },
    }));
  };

  // const handleDownloadJson = () => {
  //   const jsonString = JSON.stringify(
  //     dataJson,
  //     null,
  //     2
  //   );

  //   const blob = new Blob(
  //     [jsonString],
  //     { type: "application/json" }
  //   );

  //   const url = URL.createObjectURL(blob);
  //   const link = document.createElement("a");

  //   link.href = url;
  //   link.download = "data.json";
  //   document.body.appendChild(link);
  //   link.click();
  //   link.remove();
  //   URL.revokeObjectURL(url);
  // };

  const handleLoadJson = (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const text = e.target.result;
        const parsed = JSON.parse(text);

        if (typeof parsed !== "object") {
          toastAlert("Archivo inválido", "error");
          return;
        }

        const normalized = {
          previewLastUpdate: parsed.previewLastUpdate || null,
        };

        Object.entries(parsed).forEach(([key, value]) => {
          if (key === "previewLastUpdate") return;

          normalized[key] = {
            lastUpdate: value.lastUpdate || getCurrentDate(),
            ...value,
          };
        });

        setDataJson(normalized);

        const firstDoc = Object.keys(parsed)[0];

        if (firstDoc) {
          setDocId(Number(firstDoc));
        }

        toastAlert("JSON cargado correctamente", "success");
      } catch (error) {
        toastAlert("Error al leer JSON", "error");
      }
    };

    reader.readAsText(file);
  };

  const handleSyncAudios = async () => {
    const result = await syncAudios();
    if (result.success) {
      toastAlert(result.message, "success");
      refetchJson();
    } else {
      toastAlert(result.message, "error");
    }
  };

  const availableOptions =
    opcionesData.filter((item) =>
      allowedModules.includes(item.Id_Option)
    );

  const currentData = dataJson[docId] ||
    (docId === 1001
      ? {
        lastUpdate: getCurrentDate(),
        Secciones: {
          titulo: "",
          secciones: [],
        },
      } : {
        lastUpdate: getCurrentDate(),
        Panorama: "",
        Pay: [],
        Indicadores: {
          Financieros: [],
          Economia: [],
          Criptomonedas: [],
        },
      });

  const handleUploadAudio = async (file) => {
    setIsUploading(true);

    try {
      setSelectedAudioFile(file);
      setPendingAudioDocId(docId);

      markAsUpdated(docId, "Audio");

      setDataJson((prev) => ({
        ...prev,
        [docId]: {
          ...prev[docId],
          Audio: {
            nombre: file.name,
            size: file.size,
            previewUrl: file.name,
          },
        },
      }));

      toastAlert("Audio cargado al JSON correctamente", "success");
    } catch (error) {
      console.error("Error al convertir audio:", error);
      toastAlert("Error al procesar el archivo de audio", "error");
    } finally {
      setIsUploading(false);
    }
  };

  const handleUploadAudioCompleto = async (file) => {
    setIsUploadingCompleto(true);

    try {
      setSelectedAudioCompletoFile(file);
      setPendingAudioDocId(docId);

      markAsUpdated(docId, "AudioCompleto");

      setDataJson((prev) => ({
        ...prev,
        [docId]: {
          ...prev[docId],
          AudioCompleto: {
            nombre: file.name,
            size: file.size,
            previewUrl: file.name,
          },
        },
      }));

      toastAlert("Audio completo cargado al JSON correctamente", "success");
    } catch (error) {
      console.error("Error al procesar audio completo:", error);
      toastAlert("Error al procesar el archivo de audio completo", "error");
    } finally {
      setIsUploadingCompleto(false);
    }
  };

  const handleUploadAudioResumidoNV = async (file) => {
    setIsUploadingResumidoNV(true);

    try {
      setSelectedAudioResumidoNVFile(file);
      setPendingAudioDocId(docId);

      markAsUpdated(docId, "AudioResumidoNV");

      setDataJson((prev) => ({
        ...prev,
        [docId]: {
          ...prev[docId],
          AudioResumidoNV: {
            nombre: file.name,
            size: file.size,
            previewUrl: file.name,
          },
        },
      }));

      toastAlert("Audio resumido NV cargado al JSON correctamente", "success");
    } catch (error) {
      console.error("Error al procesar audio resumido NV:", error);
      toastAlert("Error al procesar el archivo de audio resumido NV", "error");
    } finally {
      setIsUploadingResumidoNV(false);
    }
  };

  const handleUploadAudioCompletoNV = async (file) => {
    setIsUploadingCompletoNV(true);

    try {
      setSelectedAudioCompletoNVFile(file);
      setPendingAudioDocId(docId);

      markAsUpdated(docId, "AudioCompletoNV");

      setDataJson((prev) => ({
        ...prev,
        [docId]: {
          ...prev[docId],
          AudioCompletoNV: {
            nombre: file.name,
            size: file.size,
            previewUrl: file.name,
          },
        },
      }));

      toastAlert("Audio completo NV cargado al JSON correctamente", "success");
    } catch (error) {
      console.error("Error al procesar audio completo NV:", error);
      toastAlert("Error al procesar el archivo de audio completo NV", "error");
    } finally {
      setIsUploadingCompletoNV(false);
    }
  };

  const handleUploadAudioResumidoCC = async (file) => {
    setIsUploadingResumidoCC(true);

    try {
      setSelectedAudioResumidoCCFile(file);
      setPendingAudioDocId(docId);

      markAsUpdated(docId, "AudioResumidoCC");

      setDataJson((prev) => ({
        ...prev,
        [docId]: {
          ...prev[docId],
          AudioResumidoCC: {
            nombre: file.name,
            size: file.size,
            previewUrl: file.name,
          },
        },
      }));

      toastAlert("Audio resumido CC cargado al JSON correctamente", "success");
    } catch (error) {
      console.error("Error al procesar audio resumido CC:", error);
      toastAlert("Error al procesar el archivo de audio resumido CC", "error");
    } finally {
      setIsUploadingResumidoCC(false);
    }
  };

  const handleUploadAudioCompletoCC = async (file) => {
    setIsUploadingCompletoCC(true);

    try {
      setSelectedAudioCompletoCCFile(file);
      setPendingAudioDocId(docId);

      markAsUpdated(docId, "AudioCompletoCC");

      setDataJson((prev) => ({
        ...prev,
        [docId]: {
          ...prev[docId],
          AudioCompletoCC: {
            nombre: file.name,
            size: file.size,
            previewUrl: file.name,
          },
        },
      }));

      toastAlert("Audio completo CC cargado al JSON correctamente", "success");
    } catch (error) {
      console.error("Error al procesar audio completo CC:", error);
      toastAlert("Error al procesar el archivo de audio completo CC", "error");
    } finally {
      setIsUploadingCompletoCC(false);
    }
  };

  if (isLoadingGlobal) {
    return (
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
        }}
      >
        <CircularProgress size={50} />

        <Typography variant="body1" color="text.secondary">
          Cargando información...
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        p: 2,
        borderRadius: 4,
        background: alpha(
          "#ffffff",
          0.9
        ),
        backdropFilter: "blur(10px)",
        border: "1px solid #e2e8f0",
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
        overflow: "hidden",
      }}
    >
      <input
        type="file"
        accept=".json"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleLoadJson}
      />
      <Box>
        <Tabs
          value={tabKey}
          onChange={(_, value) => setTabKey(value)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ mb: 2, borderBottom: "1px solid #e2e8f0" }}
        >
          {tabsConfig.map((tab) => (
            <Tab
              key={tab.key}
              value={tab.key}
              label={tab.label}
              disabled={
                isUploading ||
                isUploadingCompleto ||
                isUploadingResumidoNV ||
                isUploadingCompletoNV ||
                isUploadingResumidoCC ||
                isUploadingCompletoCC
              }
            />
          ))}
        </Tabs>

        <Stack
          spacing={1}
          alignItems="center"
          mb={2}
        >
          <Typography
            variant="h5"
            fontWeight={700}
          >
            Contenido complementario
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
          >
            Selecciona documento y módulo
          </Typography>
        </Stack>

        <Stack
          direction={{ xs: "column", md: "row", }}
          spacing={3}
        >
          <Tooltip title="Selecciona el tipo de documento a complementar">
            <TextField
              select
              fullWidth
              label="Documento"
              value={
                tabDocuments.some((d) => d.ID_DOCUMENTO === docId)
                  ? docId
                  : ""
              }
              onChange={(e) =>
                setDocId(Number(e.target.value))
              }
              disabled={
                loading ||
                isUploading ||
                isUploadingCompleto ||
                isUploadingResumidoNV ||
                isUploadingCompletoNV ||
                isUploadingResumidoCC ||
                isUploadingCompletoCC
              }
            >
              {tabDocuments.map(
                (doc) => (
                  <MenuItem
                    key={doc.ID_DOCUMENTO}
                    value={doc.ID_DOCUMENTO}
                  >
                    {doc.NOMBRE_DOCUMENTO}
                  </MenuItem>
                )
              )}
            </TextField>
          </Tooltip>
          <Tooltip title="Selecciona el tipo de contenido a editar">
            <TextField
              select
              fullWidth
              label="Módulo"
              value={
                allowedModules.includes(optId)
                  ? optId
                  : allowedModules[0] || ""
              }
              onChange={(e) =>
                setOptId(Number(e.target.value))
              }
              disabled={
                isUploading ||
                isUploadingCompleto ||
                isUploadingResumidoNV ||
                isUploadingCompletoNV ||
                isUploadingResumidoCC ||
                isUploadingCompletoCC
              }
            >
              {availableOptions.map(
                (opt) => (
                  <MenuItem
                    key={opt.Id_Option}
                    value={opt.Id_Option}
                  >
                    {opt.Name_Option}
                  </MenuItem>
                )
              )}
            </TextField>
          </Tooltip>
        </Stack>

        <Box
          sx={{
            mt: 3,
            p: 2,
            borderRadius: 3,
            background: "#f1f5f9",
            textAlign: "center",
          }}
        >
          <Typography
            fontWeight={500}
          >
            {textoCombinado}
          </Typography>

          <Typography
            variant="caption"
            color="text.secondary"
            component="div"
          >
            {(() => {
              const moduleMap = {
                1: "Panorama",
                2: "Pay",
                3: "Indicadores",
                4: "Secciones",
                5: "Audio",
                6: "AudioCompleto",
                7: "AudioResumidoNV",
                8: "AudioCompletoNV",
                9: "AudioResumidoCC",
                10: "AudioCompletoCC",
                11: "Temas",
              };

              const moduleName = moduleMap[optId];
              const lastUpdate = dataJson?.[docId]?.[`${moduleName}_lastUpdate`];

              return (
                <>
                  Última actualización de{" "}
                  {moduleName}:{" "}
                  {lastUpdate
                    ? new Date(lastUpdate).toLocaleString()
                    : "Sin datos almacenados"}
                </>
              );
            })()}
          </Typography>
        </Box>

        <Stack
          direction="row"
          justifyContent="flex-end"
          spacing={2}
          mt={2}
        >
          <Tooltip title="Vuelve a cargar la información del json almacenado">
            <Button
              onClick={refetchJson}
              variant="outlined"
            >
              Recargar información
            </Button>
          </Tooltip>

          <Tooltip title="Sincroniza los audios cargados automáticamente por n8n al preview">
            <Button
              onClick={handleSyncAudios}
              variant="outlined"
              color="secondary"
              disabled={loadingSync}
              startIcon={loadingSync && <CircularProgress size={20} />}
            >
              {loadingSync ? "Sincronizando..." : "Sincronizar Audios n8n"}
            </Button>
          </Tooltip>

          <Tooltip title="Guarda y abre una vista previa antes de cargar a producción">
            <Button
              variant="contained"
              startIcon={<VisibilityIcon />}
              onClick={async () => {
                if (Object.keys(dataJson).length === 0) {
                  toastAlert("No hay información para previsualizar", "warning");
                  return;
                }
                const previewDate = getCurrentDate();

                const updatedData = {
                  ...dataJson,
                  previewLastUpdate: previewDate,
                };

                Object.keys(pendingUpdatesRef.current).forEach((docKey) => {
                  const modules = pendingUpdatesRef.current[docKey];

                  if (!modules?.size) return;

                  updatedData[docKey] = {
                    ...updatedData[docKey],
                    lastUpdate: previewDate,
                  };

                  modules.forEach((moduleName) => {
                    updatedData[docKey][`${moduleName}_lastUpdate`] =
                      previewDate;
                  });
                });

                pendingUpdatesRef.current = {};
                setDataJson(updatedData);
                
                const formData = new FormData();

                formData.append("data", JSON.stringify(updatedData));
                formData.append("docId", pendingAudioDocId || docId);

                if (selectedAudioFile) {
                  formData.append("audioFile", selectedAudioFile);
                }
                if (selectedAudioCompletoFile) {
                  formData.append("audioCompletoFile", selectedAudioCompletoFile);
                }
                if (selectedAudioResumidoNVFile) {
                  formData.append("audioResumidoNVFile", selectedAudioResumidoNVFile);
                }
                if (selectedAudioCompletoNVFile) {
                  formData.append("audioCompletoNVFile", selectedAudioCompletoNVFile);
                }
                if (selectedAudioResumidoCCFile) {
                  formData.append("audioResumidoCCFile", selectedAudioResumidoCCFile);
                }
                if (selectedAudioCompletoCCFile) {
                  formData.append("audioCompletoCCFile", selectedAudioCompletoCCFile);
                }

                const ok = await saveJson(formData);

                if (ok) {
                  setIsSaved(true);
                  setOpenPreview(true);
                  setSelectedAudioFile(null);
                  setSelectedAudioCompletoFile(null);
                  setSelectedAudioResumidoNVFile(null);
                  setSelectedAudioCompletoNVFile(null);
                  setSelectedAudioResumidoCCFile(null);
                  setSelectedAudioCompletoCCFile(null);
                  setPendingAudioDocId(null);
                  toastAlert("JSON guardado correctamente", "success");
                } else {
                  toastAlert("Error al guardar JSON", "error");
                }
              }}
              sx={{ background: "linear-gradient(95deg,#059669,#047857)" }}
            >
              Vista previa
            </Button>
          </Tooltip>

          {/* <Tooltip title="Carga un archivo JSON desde tu equipo">
            <Button
              variant="contained"
              startIcon={<UploadFileIcon />}
              onClick={() => fileInputRef.current.click()}
              sx={{
                background: "linear-gradient(95deg,#7c3aed,#6d28d9)",
              }}
            >
              Importar JSON
            </Button>
          </Tooltip> */}

          {/* <Tooltip title="Descarga el JSON actual">
            <Button
              variant="contained"
              startIcon={<DownloadIcon />}
              onClick={handleDownloadJson}
            >
              Exportar JSON
            </Button>
          </Tooltip> */}
        </Stack>
      </Box>
      <Box
        sx={{
          mt: 3,
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
        }}
      >
        {optId === 1 && (
          <Panorama
            value={currentData.Panorama}
            onChange={updatePanorama}
          />
        )}

        {optId === 2 && (
          <Pay
            value={currentData.Pay}
            onChange={updatePay}
          />
        )}

        {optId === 3 && (
          <Indicadores
            value={currentData.Indicadores}
            onChange={updateIndicadores}
          />
        )}

        {optId === 4 && docId === 1001 && (
          <Secciones
            value={currentData.Secciones}
            onChange={updateSecciones}
          />
        )}

        {optId === 5 && (
          <AudioUpload
            onUpload={handleUploadAudio}
            onDelete={() => handleDeleteAudio("Audio")}
            loading={isUploading || !!pendingAudioDocId}
            existingAudio={dataJson[docId]?.Audio}
            markers={dataJson[docId]?.Audio_marcadores || []}
            onMarkersChange={(value) => updateMarkers("Audio", value)}
            docId={docId}
            moduleKey="Audio"
          />
        )}

        {optId === 6 && (
          <AudioUpload
            onUpload={handleUploadAudioCompleto}
            onDelete={() => handleDeleteAudio("AudioCompleto")}
            loading={isUploadingCompleto || !!pendingAudioDocId}
            existingAudio={dataJson[docId]?.AudioCompleto}
            markers={dataJson[docId]?.AudioCompleto_marcadores || []}
            onMarkersChange={(value) => updateMarkers("AudioCompleto", value)}
            docId={docId}
            moduleKey="AudioCompleto"
          />
        )}

        {optId === 7 && (
          <AudioUpload
            onUpload={handleUploadAudioResumidoNV}
            onDelete={() => handleDeleteAudio("AudioResumidoNV")}
            loading={isUploadingResumidoNV || !!pendingAudioDocId}
            existingAudio={dataJson[docId]?.AudioResumidoNV}
            markers={dataJson[docId]?.AudioResumidoNV_marcadores || []}
            onMarkersChange={(value) => updateMarkers("AudioResumidoNV", value)}
            docId={docId}
            moduleKey="AudioResumidoNV"
          />
        )}

        {optId === 8 && (
          <AudioUpload
            onUpload={handleUploadAudioCompletoNV}
            onDelete={() => handleDeleteAudio("AudioCompletoNV")}
            loading={isUploadingCompletoNV || !!pendingAudioDocId}
            existingAudio={dataJson[docId]?.AudioCompletoNV}
            markers={dataJson[docId]?.AudioCompletoNV_marcadores || []}
            onMarkersChange={(value) => updateMarkers("AudioCompletoNV", value)}
            docId={docId}
            moduleKey="AudioCompletoNV"
          />
        )}

        {optId === 9 && (
          <AudioUpload
            onUpload={handleUploadAudioResumidoCC}
            onDelete={() => handleDeleteAudio("AudioResumidoCC")}
            loading={isUploadingResumidoCC || !!pendingAudioDocId}
            existingAudio={dataJson[docId]?.AudioResumidoCC}
            markers={dataJson[docId]?.AudioResumidoCC_marcadores || []}
            onMarkersChange={(value) => updateMarkers("AudioResumidoCC", value)}
            docId={docId}
            moduleKey="AudioResumidoCC"
          />
        )}

        {optId === 10 && (
          <AudioUpload
            onUpload={handleUploadAudioCompletoCC}
            onDelete={() => handleDeleteAudio("AudioCompletoCC")}
            loading={isUploadingCompletoCC || !!pendingAudioDocId}
            existingAudio={dataJson[docId]?.AudioCompletoCC}
            markers={dataJson[docId]?.AudioCompletoCC_marcadores || []}
            onMarkersChange={(value) => updateMarkers("AudioCompletoCC", value)}
            docId={docId}
            moduleKey="AudioCompletoCC"
          />
        )}

        {optId === 11 && (
          <Temas
            value={currentData.Temas}
            onChange={updateTemas}
          />
        )}
      </Box>

      <PreviewModal
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        onPublish={publishJson}
        loading={loadingSend}
        isSaved={isSaved}
        onReload={refetchJson}
      />
    </Paper>
  );
};
